import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DecimalPipe} from "@angular/common";

@Component({
    selector: 'app-sanierung-introduction',
    templateUrl: './sanierung-introduction.component.html',
    providers: [DecimalPipe],
    standalone: false
})
export class SanierungIntroductionComponent  {
  /**
   * factor to be used to display the chart bars
   */
  barFactor: number = 1;

  /**
   * current consumption
   */
  current: number;

  /**
   * really needed consumption
   */
  needed: number;

  /**
   * bar height of current consumption
   */
  currentHeight: string;

  /**
   * bar height of really needed consumption
   */
  neededHeight: string;

  /**
   * deviation from current and really needed consumption
   */
  isDeviated: boolean;

  /**
   * sanizized consumption
   */
  sanitized: number;

  /**
   * placeholders for the text
   */
  placeholder: {percent: string, sign: string, co2_current: string, co2_sanitized: string, energy_source: string};

  /**
   * constructor
   * @param data
   * @param decimalPipe
   * @param dialogRef
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: {path: string, case: number, current:number, needed: number, deviation: string, energy_source: string, sanitized: number, unit: string, co2_current: number, co2_sanitized: number}, private decimalPipe: DecimalPipe, private dialogRef: MatDialogRef<SanierungIntroductionComponent>) {
    // init plaxceholder
    this.placeholder = {
      percent: decimalPipe.transform((1 - (data.sanitized / data.current)) * 100, '1.0-0'),
      sign: data.sanitized > data.current? '+' : '-',
      co2_current: decimalPipe.transform(data.co2_current, '1.0-1'),
      co2_sanitized: decimalPipe.transform(data.co2_sanitized, '1.0-1'),
      energy_source: data.energy_source
    };

    // set current and sanitized value
    this.current = data.current;
    this.sanitized = data.sanitized;
    if(data.unit === 'co2') {
      this.current = data.co2_current;
      this.sanitized = data.co2_sanitized;
    }
    // set really needed comsumption and the deviation from current value
    this.needed = data.needed;
    this.isDeviated = data.deviation === "zu_hoch" || data.deviation === "zu_niedrig";

    // set barfactor after a litle timeout for a small animation
    setTimeout(() => {
      // case: no high/low deviation from current to needed energy amount
      if (!this.isDeviated) {
        if (data.unit === 'co2') {
          this.barFactor = this.data.co2_sanitized / this.data.co2_current;
        }
        else {
          this.barFactor = this.data.sanitized / this.data.current;
        }
      }
      else {
        // case: high/low deviation - get the max value and calculate the height of bars
        const maxValue = Math.max(this.data.current, this.data.needed);
        this.currentHeight = (this.data.current / maxValue) * 100 + '%';
        this.neededHeight = (this.data.needed / maxValue) * 100 + '%';
      }
    }, 200);
  }

  /**
   * close the dialog
   */
  closeDialog(): void {
    this.dialogRef.close();
  }
}
